import FeatShield from "../../../assets/featureSheild.png"
import FeatMagnifier from "../../../assets/featuremagnifier.png"
import FeatNutrients from "../../../assets/featureneutriant.png"
import FeatBooster from "../../../assets/featurebooster.png"
import FeatGurantee from "../../../assets/featuregurantee.png"
import FeatBreathing from "../../../assets/featurebreathing.png"
import Img1 from "../../../assets/image 22.png"
import Img2 from "../../../assets/magnesium-bhb.jpg.png"
import Img3 from "../../../assets/sodium-bhb.jpg.png"
import Bottle2 from "../../../assets/updated-2.png"
import Bottle3 from "../../../assets/updated-3.png"
import Bottle6 from "../../../assets/updated-6.png"
import Fda from "../../../assets/Figure → fda.png.png"
import Gmo from "../../../assets/Figure → gmo.png.png"
import Gmp from "../../../assets/Figure → gmp.png.png"
import Nat from "../../../assets/Figure → nat.png.png"
import Usa from "../../../assets/Figure → usa.png.png"


export const features = [
    {
        icon: FeatShield,
        title: 'Mucus Relief',
        description: 'Rapidly dissolve and clear stubborn, trapped mucus that restricts airways and breath.'
    },
    {
        icon: FeatMagnifier,
        title: 'Fast Clearance Solutions',
        description: 'Swiftly open up your air passages with potent natural ingredients backed by scientific research.'
    },
    {
        icon: FeatNutrients,
        title: 'Natural Ingredients',
        description: 'Trust in a doctor-approved blend of herbal extracts and nutrients known for their respiratory benefits.'
    },
    {
        icon: FeatBooster,
        title: 'Immune Boosting',
        description: 'Bolster your body\'s defenses against pollutants, irritants, and seasonal threats to maintain resilient lungs.'
    },
    {
        icon: FeatGurantee,
        title: 'Satisfaction Guaranteed',
        description: 'Enjoy complete peace of mind with our no-hassle 180-day money-back guarantee.'
    },
    {
        icon: FeatBreathing,
        title: 'Effortless Breathing',
        description: 'Rediscover easy, refreshing inhalations and exhalations—anytime, anywhere.'
    }
];


export const ScienceBackdata = [
    {
        id: 1,
        imageSrc: Img2,
        alt: 'Groundbreaking Research',
        title: 'Groundbreaking Research',
        description: 'Developed using cutting-edge respiratory studies, Lung Renew\'s formula targets the root cause of breathing struggles.'
    },
    {
        id: 2,
        imageSrc: Img1,
        alt: 'Clinically-Proven Ingredients',
        title: 'Clinically-Proven Ingredients',
        description: 'Every component is meticulously chosen for its proven ability to melt mucus and support healthy lung function.'
    },
    {
        id: 3,
        imageSrc: Img3,
        alt: 'Doctor-Recommended Solution',
        title: 'Doctor-Recommended Solution',
        description: 'Trusted by top pulmonologists, Lung Renew is a powerful, natural approach to clearing airways and improving breath quality.'
    }
];


export const plans = [
    {
        img: "https://cdn.blackincae.com/product-images/LungRenewLabel60ML.png",
        title: '1 Bottle',
        subtitle: '30 Day Supply',
        price: 69,
        buttonText: 'BUY NOW',
        buttonColor: 'bg-yellow-400',
        url: "",
        leastpopular: true,
        popular: false,
        shipping: '9.99',
        discount: " You Save $128",
        gurantee: " 180-day money-back guarantee",
        buttonTextType: 'Basic Offer',
        old_price: "197",
        new_price: "69"
    },
    {
        img: "https://cdn.blackincae.com/product-images/LR_Bottle_Bottle_6_V2_60ML.png",
        title: '6 Bottles',
        subtitle: '180 Day Supply',
        price: 49,
        buttonText: 'BUY NOW',
        buttonColor: 'bg-orange-500',
        url: "",
        leastpopular: false,
        popular: true,
        shipping: 'free',
        discount: ' YOU SAVE $888',
        biggestdisc: ' 2 Bonuses worth $249',
        gurantee: '180-day money-back guarantee',
        buttonTextType: 'Best Offer',
        old_price: "1,182",
        new_price: "294"

    },
    {
        img: "https://cdn.blackincae.com/product-images/LR_Bottle_4_60ML.png",
        title: '3 Bottles',
        subtitle: '90 Day Supply',
        price: 59,
        buttonText: 'BUY NOW',
        url: "",
        buttonColor: 'bg-yellow-400',
        popular: false,
        shipping: 'Free',
        biggestdisc: 'Free Shipping',
        discount: "  YOU SAVE $414",
        gurantee: ' 180-day money-back guarantee',
        buttonTextType: 'Good Offer',
        old_price: "591",
        new_price: "177",
        leastpopular: false



    }
];


export const faqsData = [
    {
        question: 'Is Lung Renew right for me?',
        answer: 'If you’re struggling with chronic respiratory issues like shortness of breath, wheezing, persistent coughing, or mucus buildup, Lung Renew is designed to address these challenges at their root. Unlike conventional solutions that offer temporary relief, Lung Renew works to cleanse your lungs, repair lung tissue, and restore optimal respiratory function. Whether you’re looking to breathe more freely or improve your overall vitality, Lung Renew could be the right choice for you. Plus, with our 90-day money-back guarantee, you can try it risk-free.'
    },
    {
        question: 'How is Lung Renew different from other respiratory solutions?',
        answer: 'Most respiratory supplements and treatments, like bronchodilators, focus on symptom relief without addressing the underlying issues. Lung Renew takes a comprehensive three-step approach:\n\n1. Cleansing: Breaks down excess Mucus NETs (Neutrophil Extracellular Traps) that block airways.\n2. Repair: Supports lung tissue healing and promotes healthy respiratory function.\n3. Restoration: Clears your airways for smooth, effortless breathing.\n\nUnlike other products, Lung Renew uses 100% natural ingredients that are gentle on your body and clinically studied for their effectiveness.'
    },
    {
        question: 'Will Lung Renew help with energy and fatigue?',
        answer: 'Yes, many of our customers report noticeable improvements in energy levels. When your lungs are clear and functioning optimally, your body absorbs oxygen more efficiently. This boosts mitochondrial function—the energy powerhouses of your cells—and revitalizes your entire system. While Lung Renew’s primary goal is to improve respiratory health, enhanced energy and reduced fatigue are often pleasant side effects of better oxygen absorption.'
    },
    {
        question: 'Are there any side effects? Is it safe for long-term use?',
        answer: 'Lung Renew is made from 100% natural, plant-based ingredients and is free from dangerous drugs, stimulants, or harsh chemicals. It has been embraced by thousands of people, and no side effects have been reported. Manufactured in a state-of-the-art FDA-registered and GMP-certified facility, Lung Renew undergoes rigorous third-party testing to ensure purity, potency, and safety. It’s safe for long-term use and may even help rejuvenate your respiratory system over time.'
    },
    {
        question: 'Will Lung Renew help with mucus buildup or chronic coughing?',
        answer: 'Yes, Lung Renew is designed to target and reduce excess mucus by addressing the overproduction of Mucus NETs, which often cause airways to become clogged. As it works to clear your airways, you’ll likely experience relief from chronic coughing and mucus buildup. Many users report feeling a significant difference within weeks of starting Lung Renew.'
    },
    {
        question: 'How soon can I expect results?',
        answer: 'Results vary depending on the severity of your respiratory issues and how long you’ve been experiencing them. Many customers notice improvements in breathing, reduced mucus, and less coughing within the first few weeks. For some, benefits like increased energy and improved lung function may take longer, with consistent results typically seen over 3-6 months. To achieve the best outcomes, we recommend using Lung Renew consistently and selecting a multi-bottle package.'
    },
    {
        question: 'Can I buy Lung Renew anywhere else?',
        answer: 'No, Lung Renew is exclusively available through this website. By selling directly to our customers, we ensure the highest quality and avoid retail markups that would significantly increase the price. Each batch is manufactured in the USA and undergoes extensive testing for safety, purity, and potency. This direct-to-customer approach allows us to offer the best value while maintaining strict quality standards.'
    },
    {
        question: 'What should I do now?',
        answer: 'Take the first step towards better lung health by selecting your preferred package below. We recommend the 6-bottle package for the best value, which includes free shipping and bonus resources to support your journey. Place your order today, and start experiencing the benefits of Lung Renew. Remember, your purchase is backed by our ironclad 90-day, 100% satisfaction guarantee, so you can try it risk-free.'
    }
];


export const referencesData = [
    "https://phys.org/news/2007-05-radiation-eating-fungi.html#google_vignette",
    "https://www.mayoclinic.org/diseases-conditions/asthma-attack/expert-answers/albuterol-side-effects/faq-20058088",
    "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7780998/",
    "https://www.mayoclinic.org/diseases-conditions/copd/symptoms-causes/syc-20353679",
    "https://gispub.epa.gov/air/trendsreport/2017/#sources",
    "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2952292/",
    "https://health.clevelandclinic.org/mullein-benefits/",
    "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC8301161/",
    "https://www.webmd.com/diet/health-benefits-mullein-tea",
    "https://linkinghub.elsevier.com/retrieve/pii/S0963996913001087",
    "https://www.semanticscholar.org/paper/The-Hydroalcoholic-Extract-Obtained-from-Mentha-L.-Arruda-Mendes/23a9a60eb3836847f5e9912dd07df60fe1fc3537",
    "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3604064/",
    "https://pubmed.ncbi.nlm.nih.gov/27369807/",
    "https://pubmed.ncbi.nlm.nih.gov/37850547/",
    "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC9740624/",
    "https://pubmed.ncbi.nlm.nih.gov/23082035/",
    
];


export const icons = [
    {
        src: Gmp,
        alt: "GMP Certified",
    },
    {
        src: Fda,
        alt: "FDA Approved",
    },
    {
        src: Gmo,
        alt: "GMO Free",

    },
    {
        src: Nat,
        alt: "Natural Ingredients",

    },
    {
        src: Usa,
        alt: "USA Manufactured",
    },
];
